<template>
  <ul v-if="total > 0" class="pagination justify-content-end mb-0">
    <li class="page-item" :class="{ disabled: currentPage == 1 }">
      <a class="page-link" href="#" @click="doFirstPage" tabindex="-1">
        <i class="fas fa-angle-double-left"></i>
        <span class="sr-only">Previous</span>
      </a>
    </li>
    <li class="page-item" :class="{ disabled: currentPage == 1 }">
      <a class="page-link" href="#" @click="doPreviousPage" tabindex="-1">
        <i class="fas fa-angle-left"></i>
        <span class="sr-only">Previous</span>
      </a>
    </li>
    <li class="page-item page-number">
      <span class="k-pager-input k-label">
        Trang
        <input
          type="number"
          class="k-textbox"
          @change="pagination"
          v-model="currentPage"
        />
        /
        {{ maxPage }}
      </span>
    </li>
    <li class="page-item" :class="{ disabled: currentPage == maxPage }">
      <a class="page-link" @click="doNextPage" href="#">
        <i class="fas fa-angle-right"></i>
        <span class="sr-only">Next</span>
      </a>
    </li>
    <li class="page-item" :class="{ disabled: currentPage == maxPage }">
      <a class="page-link" @click="doLastPage" href="#">
        <i class="fas fa-angle-double-right"></i>
        <span class="sr-only">Next</span>
      </a>
    </li>
  </ul>
</template>

<script>
export default {
  name: "pagination",
  props: {
    total: {
      type: Number,
      required: true
    },
    perPage: {
      type: Number,
      default: 100
    },
    value: {
      type: Number,
      default: 100
    }
  },
  data() {
    return {
      currentPage: 1,
      maxPage: 0
    };
  },
  updated() {},
  watch: {
    total(val) {
      this.maxPage = Math.ceil(val / this.perPage);
    },
    value(val) {
      this.currentPage = val;
    }
  },
  methods: {
    doPreviousPage() {
      this.currentPage--;
      this.pagination();
    },
    doFirstPage() {
      this.currentPage = 1;
      this.pagination();
    },
    pagination() {
      this.$emit("change", this.currentPage);
    },
    doNextPage() {
      this.currentPage++;
      this.pagination();
    },
    doLastPage() {
      this.currentPage = this.maxPage;
      this.pagination();
    }
  }
};
</script>

<style></style>
